var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveFeature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1315 3085 105 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #556080;\n      }\n\n      .cls-2 {\n        fill: #26b99a;\n      }\n\n      .cls-3 {\n        fill: #424a60;\n      }\n\n      .cls-4 {\n        fill: #e7eced;\n      }\n\n      .cls-5 {\n        fill: #ebba16;\n      }\n\n      .cls-6 {\n        fill: #ef806f;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings_1_",
    "data-name": "settings (1)",
    transform: "translate(1315 3085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-1",
    d: "M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(9.824 0.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-2",
    d: "M39.936,9.291a5.123,5.123,0,0,1-3.164-8.06l.59-.8A49.7,49.7,0,0,0,23.339,5.068a6.889,6.889,0,1,1-8.362,5.326A63.8,63.8,0,0,0,7.434,17.72a5.056,5.056,0,0,1-.314,5.162L5.7,24.98l3.376,3.376L11.2,26.794a5.123,5.123,0,0,1,8.06,3.164l.481,2.491H24.52l.283-1.838A5.123,5.123,0,0,1,32.9,27.26l1.5,1.1,3.376-3.376-1.422-2.1a5.124,5.124,0,0,1,3.462-7.938l2.616-.4V9.77Z",
    transform: "translate(-5.698 -0.427)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(67.241 51.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-3",
    d: "M56.241,55a9.486,9.486,0,0,1,12.279-9.062,49.767,49.767,0,0,0,2.445-8.831,6.311,6.311,0,0,1-2.119-3.841L68.343,30H62.374L61.6,34.019a6.4,6.4,0,0,1-9.881,4.093l-3.388-2.295-4.221,4.221L46.066,42.7A6.4,6.4,0,0,1,42.11,52.778l-3.11.6v5.969l3.266.5a6.4,6.4,0,0,1,4.328,9.922l-1.778,2.622.164.164A50.165,50.165,0,0,0,58.959,61.641,9.455,9.455,0,0,1,56.241,55Z",
    transform: "translate(-39 -30)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-4",
    d: "M71.653,38.837c-.019-.019-.045-.024-.066-.043a22.348,22.348,0,0,0,4.921-9.933A50.181,50.181,0,0,0,49.931,2.284,22.33,22.33,0,0,0,40,7.2c-.017-.019-.024-.045-.043-.066L37.517,4.7a1.724,1.724,0,0,0-2.438,2.438l2.438,2.438c.021.021.05.028.071.047A22.288,22.288,0,0,0,32.247,22.5c-.026,0-.048-.014-.074-.014H28.724a1.724,1.724,0,0,0,0,3.448h3.448c.031,0,.055-.016.086-.017a22.29,22.29,0,0,0,5.329,12.878c-.021.019-.048.026-.069.047l-2.438,2.438a1.724,1.724,0,1,0,2.438,2.438l2.438-2.438c.021-.021.028-.048.047-.069a22.3,22.3,0,0,0,12.878,5.329.667.667,0,0,0-.019.084V50.07a1.724,1.724,0,1,0,3.448,0V46.622c0-.028-.014-.048-.016-.076A22.288,22.288,0,0,0,69.169,41.2c.019.021.026.05.047.071l2.438,2.438a1.724,1.724,0,1,0,2.438-2.438ZM54.586,29.381a5.172,5.172,0,1,1,5.172-5.172A5.172,5.172,0,0,1,54.586,29.381Z",
    transform: "translate(19.552 1.654)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-4",
    cx: 5.172,
    cy: 5.172,
    r: 5.172,
    transform: "translate(25.862 63.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-5",
    d: "M62.7,65.977l-4.264-1.895a.308.308,0,0,0-.034-.007,29.27,29.27,0,0,0,.452-19.319.242.242,0,0,0,.034-.007L62.624,43.3a1.723,1.723,0,1,0-1.248-3.212l-3.736,1.453c-.017.007-.028.021-.045.028A29.386,29.386,0,0,0,44.412,27.734c.009-.017.021-.028.029-.045l1.895-4.264a1.724,1.724,0,1,0-3.152-1.4l-1.895,4.264c-.009.021-.005.041-.014.062a28.878,28.878,0,0,0-19.31-.462c-.005-.017,0-.034-.009-.052L20.5,22.1a1.724,1.724,0,0,0-3.214,1.25l1.453,3.738c.005.016.017.026.024.041A29.372,29.372,0,0,0,4.92,40.434c-.026-.012-.041-.036-.069-.048L1.18,38.77A1.692,1.692,0,0,0,.1,38.7c.091,1.188.214,2.367.388,3.531l2.978,1.31c.024.01.052.007.076.016a29.173,29.173,0,0,0-1.493,5.638v0a49.689,49.689,0,0,0,2.122,5.743l.114.252q.561,1.257,1.191,2.476c.045.086.088.174.133.26a49.945,49.945,0,0,0,4.828,7.509c.071.09.141.181.214.271q.851,1.078,1.757,2.11c.041.047.081.095.122.141a50.112,50.112,0,0,0,4.236,4.236c.047.041.095.081.141.122q1.029.908,2.11,1.757c.09.072.181.143.271.214a49.945,49.945,0,0,0,7.509,4.828l.26.134q1.218.628,2.474,1.19l.252.114a49.688,49.688,0,0,0,5.743,2.122h0a29.118,29.118,0,0,0,4.328-1.047c.01.029,0,.06.016.09l.85,2.21c1.29.24,2.595.441,3.917.579l-1.545-4.024c-.009-.021-.026-.034-.034-.055A29.389,29.389,0,0,0,56.986,67.2c.019.01.031.028.05.036L61.3,69.128a1.709,1.709,0,0,0,.7.148,1.724,1.724,0,0,0,.7-3.3Zm-31.734-.148A12.069,12.069,0,1,1,43.034,53.759,12.069,12.069,0,0,1,30.965,65.828Z",
    transform: "translate(0.07 15.206)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(-901 -760)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    className: "cls-6",
    cx: 18.5,
    cy: 18,
    rx: 18.5,
    ry: 18,
    transform: "translate(969 819)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    className: "cls-7",
    width: 25.488,
    height: 3.389,
    transform: "translate(995.381 847.173) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    className: "cls-7",
    width: 25.488,
    height: 3.389,
    transform: "translate(977.358 844.778) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFeature);
export default __webpack_public_path__ + "static/media/remove-feature.887ee66a18b3170eb4a037b7afa675fc.svg";
export { ForwardRef as ReactComponent };